import React from "react";
import { Button } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

const SyncInfo = ({ lastSyncTime, onSyncNow, dataLoading }) => {
  const { t } = useTranslation();
  const formatLastSync = () => {
    if (!lastSyncTime) return "";
    try {
      const date = new Date(lastSyncTime);
      return format(date, "dd-MM-yyyy 'at' hh:mm a");
    } catch (error) {
      return "Invalid date";
    }
  };

  return (
    <div className="min-w-[170px] min-h-[52px] flex justify-between items-center gap-3 bg-white rounded-lg px-2 py-[6px] flex-1">
      <div className="text-[12px] font-[Lato] text-[#6C6A6A]">
        {t("Last Sync")}: {formatLastSync()}
      </div>
      <Button
        variant="contained"
        size="small"
        onClick={onSyncNow}
        disabled={dataLoading}
        sx={{
          backgroundColor: dataLoading ? "#9ca3af" : "#0575E6", // Change color when syncing
          "&:hover": { backgroundColor: "#0461c4" },
          borderRadius: "8px",
          textTransform: "none",
          fontWeight: 700,
          minWidth: "100px",
        }}
      >
        {dataLoading ? t("Loading..") : t("Sync Now")}
      </Button>
    </div>
  );
};

export default SyncInfo;
